import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { AmplifyProvider } from "@aws-amplify/ui-react";
import configureAuth from "./configureEnvironment/configureAuth";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import "./App.css";
import "antd/dist/reset.css";
import { routes } from "./routes";
import AuthenticatorWrapper from "./components/Utils/AuthenticatorWrapper";
import queryClient from "./queryClient";

export const shouldSkipAuth = () => process.env.REACT_APP_SKIP_AUTH === "SKIP";

if (!shouldSkipAuth()) {
  configureAuth();
}

const router = createBrowserRouter(routes);

function App() {
  return (
    <AmplifyProvider>
      <AuthenticatorWrapper>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
          {window.location.hostname === "localhost" && <ReactQueryDevtools />}
        </QueryClientProvider>
      </AuthenticatorWrapper>
    </AmplifyProvider>
  );
}

export default App;
